const zh = {
  entry: {
    default:'此网站正在使用默认收银台',
    configured: '此网站已配置自定义收银台',
    edit: '编辑收银台样式',
    copy: '复制收银台样式',
    copyWhat: '您希望将当前网站的收银台复制到哪一个网站？复制后的收银台将在您确认后生效。',
    webSite: '网站',
  },
  settings: {
    title: '自定义收银台',
    reset: '恢复默认样式',
    save: '保存并生效',
    tip: '使用特定的定义样式让收银台看上去更适合您的网站。',
    tabInfo: '浏览器标签项信息',
    tabTitle: '标签页标题',
    browserTabIconUrl: '标签页小图标',
    brand: '品牌',
    themeType: '外观风格',
    layoutType: '页面布局',
    layoutStyle: '支付方式展示布局',
    tab: '传统布局(左右tab)',
    accordion: '纵向布局',
    text: '文本',
    light: '浅色',
    dark: '深色',
    headerBg: '标题栏底色',
    cashierLogo: '品牌Logo',
    cashierLogoPosition: 'Logo 位置',
    headerText: '标题栏文案',
    themeColor: '品牌强调色',
    languages: '支持语言',
    langTips: '右侧预览显示英文，实际以您勾选为准',
    all: '全选',
    formStyle: '表单样式',
    prompt: '提示语',
    font: '字体',
    default: '默认',
    shape: '组件形状',
    round: '圆角尺寸',
    size: '组件尺寸',
    spacing: '组件间距',
    fontSize: '字号',
    showReturn: '展示返回入口',
    returnText: '返回文案',
    returnPosition: '位置',
    showPCI: '展示安全质保',
    roundedRectangle: '圆角矩形',
    squareRectangle: '方角矩形',
    fullyRounded: '全圆角',
    small: '小尺寸',
    medium: '中等尺寸',
    large: '大尺寸',
    left: '左对齐',
    center: '居中',
    right: '右对齐',
    orderInfo: '订单信息展示',
    showOrderId: '展示订单ID',
    showOrderAmount: '展示订单金额',
    showBilling: '展示账单地址',
    resultPage: '结果提示页',
    toPingPongResult: '展示PingPong提供的"支付完成页面"',
    resultAutoRedirect: '展示"支付完成页面"后自动跳转',
    resultAutoRedirectTime: '"支付完成页面"停留时长(默认3s)',
    preview: '预览',
    redirect: '跳转收银台',
    embed: '嵌入收银台',
    embedTip: '提示：嵌入式收银台仅涉及部分配置内容',
    embedLangTip: '提示：嵌入式收银台语言追随您的网页，默认为英语',
    mobileTip: '提示：移动端收银台仅涉及部分配置内容',
    cancelEdit: '确认放弃更改？',
    confirmLeave: '您的修改尚未保存生效。确定要离开页面吗？离开页面将使修改的内容丢失。',
    confirmLeave2: '确定要离开该页面吗？',
    saveSuccess: '保存成功',
    saveFailed: '保存失败，请重试',
    confirmDefault: '确定要恢复默认设置吗？',
    tips: '提示',
    notSupport: 'shopify, shopline 等建站平台的内嵌收银台不支持此功能'
  },
  upload: {
    imageSize: '图片尺寸',
    recommendFormat: '推荐格式',
    fileSize: '文件大小',
    uploadFailed: '上传失败',
    formatError: '图片格式错误',
    formatTip: '图片应为JPG、JPEG、PNG、BMP、SVG、ICO格式',
    attention: '注意',
    uploadTip: '不超过 10KB',
    uploadTip2: '32x32 像素',
    sizeError: '图片尺寸错误',
    sizeTip: '图片尺寸必须为 {size} 像素',
    failed: '失败',
    loadFailed: '无法加载图片，请重试',
    readField: '无法读取文件，请重试',
    clear: '清除',
  },
  button: {
    continue: '继续编辑',
    discard: '放弃更改',
    confirm: '确定',
    cancel: '取消'
  }
}

export default zh
